import { supabase } from '@/lib/supabase';
import { newId } from '@/lib/id';

/**
 * העלאת קובץ לשיעור, לבדל learning (מיגרציה 022).
 *
 * הנתיב הוא courses/<lesson או course>/<אקראי>.<סיומת>, ולא שם הקובץ
 * המקורי: שמות קבצים בעברית עם רווחים נשברים בדרך, ושני מנהלים שמעלים
 * "מצגת.pdf" היו דורסים זה את זה.
 */

const BUCKET = 'learning';

/** מה מותר להעלות לכל סוג שיעור, לפי ה renderer_key. */
export const ACCEPT: Record<string, string> = {
  image: 'image/jpeg,image/png,image/webp,image/gif,image/heic',
  video: 'video/mp4,video/quicktime,video/webm',
  pdf: 'application/pdf',
  slides: 'application/pdf',
};

/** קובץ שצריך העלאה, בשונה מטקסט או קישור. */
export function needsFile(rendererKey: string): boolean {
  return rendererKey in ACCEPT;
}

const MAX_BYTES = 100 * 1024 * 1024;

export function fileTooBig(file: File): boolean {
  return file.size > MAX_BYTES;
}

/** "4.2 מגה", לשורת השגיאה. */
export function sizeLabel(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} קילו`;
  return `${(bytes / 1024 / 1024).toFixed(1)} מגה`;
}

function extensionOf(file: File): string {
  const fromName = file.name.includes('.') ? file.name.split('.').pop() : null;
  if (fromName && /^[a-z0-9]{1,5}$/i.test(fromName)) return fromName.toLowerCase();
  // קובץ בלי סיומת קריאה: נגזרת מסוג ה MIME
  const fromType = file.type.split('/')[1]?.split('+')[0];
  return fromType && /^[a-z0-9]{1,5}$/i.test(fromType) ? fromType : 'bin';
}

export async function uploadLessonFile(courseId: string, file: File): Promise<string> {
  const path = `courses/${courseId}/${newId()}.${extensionOf(file)}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    contentType: file.type || 'application/octet-stream',
    upsert: false,
  });
  if (error) throw error;
  return path;
}

/** מחיקת קובץ שהוחלף. כישלון כאן לא אמור להפיל שמירה של שיעור. */
export async function removeLessonFile(path: string): Promise<void> {
  await supabase.storage.from(BUCKET).remove([path]);
}
